<div
  *ngIf="mobileProductDetails?.activeSubscription"
  class="columns small-12 medium-6"
  data-masonry-item=""
>
  <div class="panel rs-bg-grey1 rs-no-margin rs-no-radius-bottom">
    <div class="rs-flex-row rs-flex-bottom">
      <div class="rs-flex-column">
        <h3 class="rs-tit6 rs-txt-c1 rs-padding-bottom2">
          {{ mobileProductDetails?.productDescription }}
        </h3>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <p class="rs-txt-success rs-font-pxB">
          <i class="icon-Status-ok rs-margin-right1" aria-hidden="true"></i
          >{{ 'mobile.pricingPlan.actualPlan' | translate }}
        </p>
      </div>
    </div>
  </div>
  <div class="panel rs-bg-grey2 rs-no-radius-top">
    <div class="rs-flex-row rs-flex-bottom">
      <div class="rs-flex-column">
        <p class="rs-txt-purple rs-font-pxXB">
          {{ 'mobile.pricingPlan.monthlyPrice' | translate }}
        </p>
      </div>
      <div class="rs-flex-column rs-flex-shrink">
        <p>
          <px-currency-amount
            [amount]="getPrice()"
            [amountClass]="'rs-price-s'"
          ></px-currency-amount>
          /{{ 'mobile.pricingPlan.month' | translate }}
        </p>
      </div>
    </div>
    <div class="medium-text-right">
      <a
        href="javascript:void(0)"
        id="linkPricingPlan"
        data-cy="linkToPricingPlan"
        (click)="navigateToSwapSubscription(mobileProductDetails?.accessNumber)"
        class="rs-btn rs-btn-third"
        data-tms-event="link-click"
        data-tms-link-zone="mobile options"
        attr.data-tms-link-name="{{ 'mobile.pricingPlan.linkLabel' | translate }}"
        >{{ 'mobile.pricingPlan.linkLabel' | translate
        }}<i class="rs-icon-btn-third rs-margin-left1" aria-hidden="true"></i
      ></a>
    </div>
  </div>
</div>
